// extracted by mini-css-extract-plugin
module.exports = {"sidebarLink":"SidebarItem_sidebarLink__1XuzF","navLink":"SidebarItem_navLink__3s3ov","active":"SidebarItem_active__3pvaC"};